// extracted by css-extract-rspack-plugin
export default {"milestoneLink":"DemilestonedEvent-module__milestoneLink__qk8ztds"};